import { TFunction } from 'i18next';

export const LANGUAGE_TRANSLATION_MAP: Record<string, string> = {
  en: 'learner.3829', // English
  'zh-CN': 'learner.3832', // 中文 (Simplified Chinese)
  ko: 'learner.3828', // 한국어
  km: 'learner.3863', //  (Khmer)
  ar: 'learner.3830', //  (Arabic)
  'zh-TW': 'learner.3833', //  (Traditional Chinese)
  es: 'learner.3856', //  (Spanish)
  th: 'learner.3858', // (Thai)
  hi: 'learner.3850', // (Hindi)
};

export function getLanguageTranslationKey(code: string, t: TFunction): string {
  const translationKey = LANGUAGE_TRANSLATION_MAP[code] || '';
  const translatedName = t(translationKey);
  return translatedName;
}

/**
 * 언어 코드를 정규화합니다
 * - zh로 시작하는 경우 (zh-CN, zh-TW): 전체 코드 유지
 * - 그 외 언어: 앞 두 자리만 반환
 * 예: 'zh-CN' -> 'zh-CN', 'zh-TW' -> 'zh-TW', 'en-US' -> 'en', 'ko-KR' -> 'ko'
 * @param code 언어 코드 (예: 'en-US', 'ko-KR', 'zh-CN', 'en')
 * @returns 정규화된 언어 코드
 */
export function normalizeLanguageCode(code: string): string {
  if (!code || typeof code !== 'string') {
    return 'ko'; // 기본값
  }
  const splitLangCode = code.split('-');
  // zh인 경우는 전체 코드 유지 (zh-CN, zh-TW 구분 필요)
  if (splitLangCode[0].toLowerCase() === 'zh') {
    return code;
  }
  return splitLangCode[0].toLowerCase();
}
